import React, { Component } from 'react';
import {
  imageBasePath
} from '../../library/constants';
import './index.css';
import {
  isMobileTablet,
} from '../../library/calc';

import { data } from '../../version/dataVersion.js';

class Config extends Component {

  render () {

    const { canvasHeight, showModal, hideProductTour } = this.props;

    let configureStyle = {
      top: `${ canvasHeight + this.props.canvasTop - 380 + (this.props.canvasTop * -1) }px`,
      left: '57px',
      background: `url(${imageBasePath}configure.svg?cacheBust=${data.version}) no-repeat `,
      backgroundSize: 'contain',
      width: '25px',
      height: '25px',
      position: 'absolute',
      cursor: 'pointer',
      opacity: .5,
    };

    if( this.props.stageBackgroundCustomColor === '#000000'){
      configureStyle = {...configureStyle, ...{
        background: `url(${imageBasePath}configure_blk_bg.svg?cacheBust=${data.version}) no-repeat `,
        opacity: .7,
      }};
    }

    if(isMobileTablet()){
      configureStyle.top = `${ canvasHeight - 110 }px`;
      configureStyle.left = '44.5px';
    }

    return (

        isMobileTablet() && this.props.isDualPedigree

        ?

          null

        :

      <div className="desktopBoxControls">
        <div id="preferences-div" style={{
            ...configureStyle,
            background: `${ ( isMobileTablet() ? 'transparent': 'white')}`,
          }} >
          <div
             id="preferences-icon"
            style={{
              ...configureStyle,
              top: '0px',
              left: '0px',
            }}
            onClick={
              ()=>{
                const whichModalScreen = `Config`;
                hideProductTour({fromWhere: '93594395', withLastStepNotify: true});
                showModal({whichModalScreen});
              }
            }
            >
          </div>
        </div>
      </div>


    );
  }
}

export default Config;
